import Analytics from 'analytics'
import googleAnalytics from '@analytics/google-analytics'
import googleTagManager from '@analytics/google-tag-manager'

export default function(config) {
    let plugin = null

    const pluginConfig = {
        instanceName: 'rocketeffect',
    }

    switch (config.script_type) {
        case 'ga': {
            const localPluginConfig = Object.assign(pluginConfig, {
                measurementIds: [config.id],
                dataLayerName: 'dataLayerForRocketEffect',
                gtagName: 'gtagForRocketEffect',
            })

            if (config.debug) {
                localPluginConfig.debug = true
            }

            plugin = googleAnalytics(localPluginConfig)
            break
        }
        case 'gtag':
            plugin = googleTagManager(Object.assign(pluginConfig, {
                containerId: config.id,
                dataLayerName: 'dataLayerForRocketEffect',
                gtagName: 'gtagForRocketEffect',
            }))
            break
        default:
            return
    }

    const analytics = Analytics({
        app: 'Rocket Effect',
        debug: config.debug || false,
        plugins: [plugin],
    })

    analytics.instanceName = pluginConfig.instanceName
    analytics.instancePrefix = pluginConfig.instanceName + '.'

    config.analytics = analytics

    analytics.page()

    return analytics
}
